<template>
  <div class="">
    <button class="btn btn-primary rounded-pill btn-sm mx-1" @click="createCustomClass()">ساخت کلاس</button>


    <div class="my-3" v-for="itemClass in componentClass">

      <class-box-scss :item-class="itemClass"/>
      <button class="btn btn-primary rounded-pill btn-sm my-1 mx-1" @click="buildScss">build</button>
    </div>


  </div>
</template>

<script>
import {generateRandomString} from "@/store/Modules/Site";
import ClassBoxScss from "@/components/ComponentSettingComponents/CustomClassHandler/ClassBoxScss.vue";

export default {
  name: "CustomClassHandler",
  components: {ClassBoxScss},
  props: {
    component: {}
  },
  computed: {
    componentClass() {
      return this.component.class.split(' ').filter(item => {
        return item.includes('miw-')
      })
    }
  },
  methods: {
    generateClass() {
      return `miw-${generateRandomString().slice(0, 12)}`
    },
    createCustomClass() {
      let newClass = this.generateClass()
      this.component.class += ` ${newClass}`
      let globalCss = this.$store.getters['Site/getGlobalStyle'];
      globalCss =
          globalCss
          +
          `\n\n .${newClass}{}`
      this.$store.dispatch('Site/setGlobalStyle', globalCss)
    },
    buildScss() {
      document.querySelector('#save-global-style').click()
    }
  }
}
</script>

<style scoped>

</style>